import { View } from 'foundations-components/components/View';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useHighestProductLevelFromInventory } from '../../hooks/inventory/useHighestProductLevel';
import { withErrorBoundary } from '../error-boundary/withErrorBoundary';
import { CustomError } from '../error-boundary/CustomErrors';
import { UnlockAIContent } from './UnlockAIContent';
import { UnlockAIContentTabLayout } from './UnlockAIContentTabLayout';
import { SingleSkeletonLoader } from '../SingleSkeletonLoader';
import { jsx as _jsx } from "react/jsx-runtime";
const UnlockAISectionBase = () => {
  const isMobile = useIsMobile();
  const {
    highestProductLevel,
    loading: highestProductLevelLoading,
    error: highestProductLevelError
  } = useHighestProductLevelFromInventory();
  const isFree = highestProductLevel === 'FREE';
  if (highestProductLevelError) {
    throw new CustomError('Failed getting highest product level from inventory', {
      error: highestProductLevelError
    });
  }
  if (highestProductLevelLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 1000,
      width: "100%"
    });
  }
  return /*#__PURE__*/_jsx(PageSection, {
    use: isMobile ? 'default' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      paddingBlock: isMobile ? '800' : '0',
      children: isFree ? /*#__PURE__*/_jsx(UnlockAIContentTabLayout, {}) : /*#__PURE__*/_jsx(UnlockAIContent, {})
    })
  });
};
export const UnlockAISection = withErrorBoundary(UnlockAISectionBase, {
  fallback: null,
  errorBoundaryName: 'UnlockAISection'
});